import * as React from 'react';
import { CloseIcon } from './CloseIcon';
import * as styles from './HomeownerTooltip.css';

type Props = {
  isOpen: boolean;
  close(): void;
};

export class HomeownerTooltip extends React.Component<Props> {
  public render() {
    const { isOpen, close } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['text']}>
          Выбирайте «Собственник», только если владеете объектом. Если это не так, вы больше не сможете размещаться как
          собственник.
        </div>
        <div onClick={close} className={styles['close-icon']}>
          <CloseIcon />
        </div>
      </div>
    );
  }
}
